import { http } from '@/lib/api/http';
import type { AuthGoogleResponse, ApiSuccess, SessionUser } from '@/shared/types/contracts';

export async function loginWithGoogle(idToken: string): Promise<AuthGoogleResponse> {
  const { data } = await http.post<ApiSuccess<AuthGoogleResponse>>('/api/auth/google', {
    id_token: idToken,
  });
  return data.data;
}

export async function loginWithEmail(email: string, password: string): Promise<AuthGoogleResponse> {
  const { data } = await http.post<ApiSuccess<AuthGoogleResponse>>('/api/auth/login', {
    email,
    password,
  });
  return data.data;
}

export async function getMe(): Promise<SessionUser> {
  const { data } = await http.get<ApiSuccess<SessionUser>>('/api/auth/me');
  return data.data;
}

export async function logout(): Promise<void> {
  await http.post('/api/auth/logout');
}
